module.exports = __webpack_public_path__ + "img/upload-in-progress.09943c1e.svg";